import React from 'react';
import { RADAR_STATE } from './PlayerRadar.constants';
import { RADAR_DISPLAY_MODE } from '../PlayerComparison/PlayerComparison.constants';

export const radarTemplateTooltipContent = (
  <div style={{ maxWidth: '200px' }}>
    Controls which metrics are displayed on the radar spokes.
  </div>
);

export const radarPositionsTooltipContent = (
  <div style={{ maxWidth: '200px' }}>
    Select &lsquo;By Alignment position&rsquo; to only show data when the player
    lined up in particular position(s).
  </div>
);

export const getRadarCardState = (isLoading, hasError, data, radarType) => {
  if (isLoading) {
    return {
      state: RADAR_STATE.LOADING,
      title: 'Loading',
      description: `Please wait loading ${radarType} data.`,
    };
  }
  if (data && Object.keys(data).length === 0 && !hasError) {
    return {
      state: RADAR_STATE.EMPTY,
      title: 'No template available',
      description: `No ${radarType} radar template available for this player.`,
    };
  }
  if (data && data?.plays === 0 && !hasError) {
    return {
      state: RADAR_STATE.EMPTY,
      title: 'No data available',
      description: `No ${radarType} data available for this player.`,
    };
  }
  if (!isLoading && hasError) {
    return {
      state: RADAR_STATE.ERROR,
      title: 'Error',
      description: `An error occurred while loading player ${radarType} data.`,
    };
  }
  return {
    state: null,
    title: '',
    description: ``,
  };
};

export const getRadarExportType = (type) => {
  switch (type) {
    case RADAR_DISPLAY_MODE.BOTH:
      return 'both';
    case RADAR_DISPLAY_MODE.TRAIT:
      return 'trait';
    case RADAR_DISPLAY_MODE.PERFORMANCE:
      return 'performance';
    default:
      return '';
  }
};

export const info2Copy = (allPlays, showLeagueAverage) => {
  const posTypeName = allPlays ? 'Roster Positions' : 'Alignment Positions';
  if (showLeagueAverage) {
    return `Versus League Average, ${posTypeName}`;
  }
  return posTypeName;
};
